<template>
    <div class="container-fluid">
        <div class="card bg-white chats-con">
            <div class="chats">
                <ol v-if="thread" class="messages" id="chatBox">
                    <li class="message" v-for="(msg, i) in threadMessages" :key="i">
                        <div class="other" v-bind:class="{ 'me' : alignRight(msg.senderId) }">
                            <div class="message-body">
                                <!-- display cash request msg -->
                                <template v-if="msg.type == 'request'">
                                    <div class="cash-request-bg"><i class="fas fa-money-check text-dark-green"></i> {{msg.content}}</div>
                                    <!-- buyer or receivers view -->
                                    <template v-if="thread.buyer.id === user._id">
                                        <p class="text text-break">
                                            {{otherUser.name | capitalize}} has requested, that you pay  
                                            <b class="text-uppercase text-dark-green">{{msg.currency}} {{msg.price | money}}</b> for this item instead
                                        </p>
                                        <!-- if request was approved -->
                                        <template v-if="!msg.approved">
                                            <button @click="approveRequestFxn(msg._id)" class="loadn btn btn-dark-green btn-sm mr-1">approve</button>
                                            <button @click="declineRequestFxn(msg._id)" class="loadn btn btn-danger btn-sm ml-1">decline</button>
                                        </template>
                                        <template v-else>
                                            <span class="font-italic">
                                                <i class="fas fa-thumbs-up text-dark-green"></i> Request approved. Smart choice!
                                            </span>
                                        </template>
                                    </template>
                                    <!-- seller or senders view -->
                                    <template v-else>
                                        <p class="text text-break">
                                            You requested <b class="text-uppercase text-dark-green">{{msg.currency}} {{msg.price | money}}</b> 
                                            from {{otherUser.name | capitalize}} for this item instead
                                        </p>
                                        <!-- if request was approved -->
                                        <span v-if="!msg.approved" class="font-italic">awaiting {{otherUser.name}}'s response...</span>
                                        <span v-else class="font-italic">
                                            <i class="fas fa-thumbs-up text-dark-green"></i> {{otherUser.name | capitalize}} approved your request!
                                            <div class="mt-3 text-center">
                                                <a href="http://localhost:4500/">
                                                    <img src="http://localhost:4500/img/g1345.png" width="170" alt="carryna">
                                                </a>
                                            </div>
                                        </span>
                                    </template>
                                </template>
                                
                                <!-- display cash request response msg -->
                                <template v-else-if="msg.type == 'alert'">
                                    <div class="cash-request-bg"><i class="fas fa-money-check text-dark-green"></i> CASH RESPONSE</div>
                                    <!-- buyer or receivers view -->
                                    <template v-if="thread.buyer.id === user._id">
                                        <p class="text text-break font-italic">
                                            <span v-if="msg.approved">
                                                <i class="far fa-smile text-dark-green"></i> 
                                                You approved {{otherUser.name | capitalize}}'s cash request!
                                                <div class="mt-3 text-center">
                                                    <a href="http://localhost:4500/">
                                                        <img src="http://localhost:4500/img/g1345.png" width="170" alt="carryna">
                                                    </a>
                                                </div>
                                            </span>
                                            <span v-else>
                                                <i class="far fa-frown text-dark-green"></i> 
                                                You declined {{otherUser.name | capitalize}}'s cash request!
                                            </span>
                                        </p>
                                    </template>
                                    <!-- seller or senders view -->
                                    <template v-else>
                                        <p class="text text-break font-italic">
                                            <i v-if="msg.approved" class="far fa-smile text-dark-green"></i>
                                            <i v-else class="far fa-frown text-dark-green"></i>
                                            {{msg.content}}
                                        </p>
                                    </template>
                                </template>
                                
                                <!-- display regular chat msg -->
                                <p v-else class="text text-break">
                                    {{msg.content}}
                                </p>
                                <span class="float-right status">
                                    <span class="mdi mdi-check-all text-primary"></span>
                                </span>
                                <span class="time">
                                    {{msg.joined | moment("LT")}} 
                                    <i v-if="msg.readStatus" class="fas fa-check-circle text-dark-green"></i>
                                    <i v-else class="far fa-check-circle"></i>
                                </span>
                            </div>
                        </div>
                    </li>
                </ol>
                <div v-else class="text-center text-muted">
                    <i class="far fa-comment-alt fa-4x mt-5"></i>
                    <p class="mt-3">On the sidebar, click on an item to display the message thread</p>
                </div>
            </div>
            <!-- new message box -->
            <div v-if="thread" class="row bg-light m-0">
                <div class="col-12 new-message-box">
                    <!-- show message box -->
                    <textarea v-if="showMessageBox" v-on:keyup.shift.enter="sendMessage" v-model="content" 
                    class="form-control no-lines bg-white" placeholder="Type your message" rows="4"></textarea>
                    <!-- show request box -->
                    <div v-else class="cash-request-box">
                        <!-- only display the request box if the item hasn't been marked-as-sold -->
                        <template v-if="!thread.item.sold">
                            <p>
                                How much will you like to request from 
                                <b class="text-dark-green">{{otherUser.name | capitalize}}</b> for this item instead? 
                            </p>
                            <div class="input-group cash-request-box-actions offset-md-4 col-md-4 col-12">
                                <div class="input-group-prepend">
                                    <div class="input-group-text bg-light text-dark-green"><i class="fas fa-money-check"></i></div>
                                </div>
                                <input v-model="price" type="number" class="form-control no-lines bg-white" placeholder="Enter your price">
                                <div class="input-group-append">
                                    <div class="input-group-text bg-light text-dark-green text-uppercase font-weight-bold">
                                        {{user.currency}}
                                    </div>
                                </div>
                            </div>
                        </template>
                        <!-- display if the item has been marked-as-sold -->
                        <template v-else>
                            <p>
                                This item has already been sold to 
                                <b><router-link :to="{ name: 'lookup-handle', params: { handle: thread.item.soldToUser.handle } }" class="text-dark-green">
                                    {{thread.item.soldToUser.name | capitalize}}
                                </router-link></b>
                                for the price of <span class="text-uppercase">{{user.currency}}</span> {{thread.item.soldToUser.soldPrice | money}} 
                                on {{thread.item.soldToUser.soldTime | moment("MMM D 'YY hh:mm A")}} and can no longer send Cash Requests!
                            </p>
                        </template>
                    </div>
                    <div class="new-message-options clearfix">
                        <div class="class float-left">
                            <button class="btn btn-outline-dark mr-1"><i class="far fa-smile"></i></button>
                            <!-- only show the send-cash-request-btn to the seller -->
                            <template v-if="thread && thread.seller.id === user._id">
                                <button v-if="showMessageBox" @click="showMessageBox = false" class="btn btn-outline-dark ml-1">
                                    <i class="fas fa-money-check"></i> 
                                    <span class="new-message-options-text">
                                     REQUEST
                                    </span>
                                </button>
                                <button v-else @click="showMessageBox = true" class="btn btn-outline-dark ml-1">
                                    <i class="fas fa-comments"></i> 
                                    <span class="new-message-options-text">
                                     MESSAGE
                                    </span>
                                </button>
                            </template>
                        </div>
                        <div class="class float-right">
                            <button v-if="showMessageBox" @click="sendMessage" v-bind="{'disabled' : ensureContent}" class="btn btn-dark-green">
                                <i class="fas fa-paper-plane"></i> SEND
                            </button>
                            <button v-else @click="sendMessage" v-bind="{'disabled' : ensurePrice}" class="btn btn-dark-green">
                                <i class="fas fa-paper-plane"></i> SEND REQUEST
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import io from 'socket.io-client'

export default {
    name: "Display",
    data() {
        return {
            showMessageBox: true,
            approved: false,
            msgType: '',
            price: '',
            content: '',
            threadMessages: []
        }
    },
    methods: {
        ...mapActions(['sendNewMessage', 'approveRequest', 'declineRequest']),
        alignRight(senderId) {
            if(senderId == this.user._id){
                return true
            }
            return false
        },
        sendMessage() {
            // in case a cash-request was sent
            if(this.price > 0){
                this.content = "CASH REQUEST"
                this.msgType = "request"
            }
            if(this.content.trim() !== ''){ 
                // prepare the message obj to be sent over the messages API
                let messageObj = {
                    sellerId: this.msgThread.seller.id,
                    buyerId: this.msgThread.buyer.id,
                    itemId: this.msgThread.item.id,
                    content: this.content,
                    senderId: this.user._id,
                    type: this.msgType,
                    approved: this.approved
                }
                // check if cash request price was included
                if(this.price > 0){
                    messageObj.price = this.price
                    messageObj.currency = this.user.currency
                }
                if(this.theReceiverId){
                    messageObj.receiverId = this.theReceiverId
                }
                this.sendNewMessage(messageObj)
                .then((sentMsgObj) => {
                    /** 
                     * append the newly saved message as parameter to be sent via socket.io 
                     * to our nodejs API, which enables the later receivedMsgObj in mounted 
                     * to have the needed msg.parameters like msg.joined to display as chats
                     * */
                    this.socket.emit('SEND_MESSAGE', sentMsgObj)
                    this.content = ""
                    this.price = ""
                    this.msgType = ""
                    this.approved = false
                })
            }
        },
        scrollToBottom() {
            let box = document.getElementById('chatBox')
            box.scrollTop = box.scrollHeight
        },
        approveRequestFxn(msgId) {
            let messageObj = {
                itemId: this.msgThread.item.id,
                msgId
            }
            this.approveRequest(messageObj)
            .then(() => {
                this.content = "Yaaaaaaay! Your cash request was approved!"
                this.msgType = "alert"
                this.approved = true
                this.sendMessage()
            })
            .catch((e) => {})
        },
        declineRequestFxn(msgId) {
            let messageObj = {
                msgId
            }
            this.declineRequest(messageObj)
            .then(() => {
                this.content = "Unfortunately, your cash request was declined!"
                this.msgType = "alert"
                this.sendMessage()
            })
            .catch((e) => {})
        },
    },
    computed: {
        ...mapGetters(['msgThread', 'user']),
        thread() {
            if(this.msgThread && this.msgThread !== null){
                this.threadMessages = this.msgThread.messages
                return this.msgThread
            }
            return false
        },
        otherUser() {
            if(this.thread){
                if(this.thread.seller.id == this.user._id){
                    return this.thread.buyer
                }else{
                    return this.thread.seller
                }
            }
            return false
        },
        theReceiverId() {
            if(this.thread){
                if(this.thread.seller.id == this.user._id){
                    return this.thread.buyer.id
                }else{
                    return this.thread.seller.id
                }
            }
            return false
        },
        ensureContent() {
            if(this.content.trim().length > 0){
                return false
            }
            return true
        },
        ensurePrice() {
            if(this.price.trim().length > 0 && this.price > 0){
                return false
            }
            return true
        },
        socket() {
            return io(process.env.VUE_APP_API_URL)
        },
    },
    watch: {
        threadMessages(){
            this.scrollToBottom()
        }
    },
    mounted() {
        /** 
         * append the newly sent message to the messages array 
         * to be looped and displayed as new chat
         * */
        this.socket.on('RECEIVE_MESSAGE', (receivedMsgObj) => {
            this.threadMessages.push(receivedMsgObj)
            this.scrollToBottom()
        })
    }
}
</script>